import { Chip } from '@mui/material';
import React from 'react';
import { AccessKeyStatus } from 'types/accessKeys';
import { ChipPropsColor } from 'types/common';

interface IAccessKeyStatusChip {
	status?: AccessKeyStatus;
}

const AccessKeyStatusChip: React.FC<IAccessKeyStatusChip> = ({ status }) => {
	let color: ChipPropsColor = 'error';

	switch (status) {
		case AccessKeyStatus.active:
			color = 'info';
			break;
		default:
			color = 'default';
			break;
	}

	return (
		<Chip
			label={intl.tr(`accessKeys.status.${status}`)}
			title={intl.tr(`accessKeys.status.${status}`)}
			variant="outlined"
			size="small"
			color={color}
		/>
	);
};

AccessKeyStatusChip.defaultProps = {
	status: AccessKeyStatus.inactive
};

export default AccessKeyStatusChip;
